export function isAccountNumberValid(accountNumber: string): boolean {
  const matches = /^-?[0-9]{6}$/.test(accountNumber);
  return matches;
}

export function isBusinessRefValid(businessRef: string): boolean {
  return /^-?[0-9]{6}$/.test(businessRef);
}

export function formatBusinessRef(value: string): string {
  return value
    .replace(/[^\d-]/g, "")
    .replace(/(-.*)-+/g, "$1")
    .replace(/^(-)?(\d{1,6})?.*/, "$1$2");
}

export function isEmailValid(email: string): boolean {
  const matches = String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
  return matches !== null && matches.length > 0;
}
